import React, { useState } from "react";
import { NormalizedDataItem } from "./useExportData";

export function useExportSelection(
  results: NormalizedDataItem[],
  currentVisibleRows: NormalizedDataItem[],
  dataMode: 'full' | 'paginated' | null
) {
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());
  const [selectAllMode, setSelectAllMode] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleSelectRow = (id: number) => {
    setSelectAllMode(false);
    const newSelectedIds = new Set(selectedIds);
    if (newSelectedIds.has(id)) {
      newSelectedIds.delete(id);
    } else {
      newSelectedIds.add(id);
    }
    setSelectedIds(newSelectedIds);
  };

  const handleSelectAllClick = () => {
    if (selectedIds.size > 0 || selectAllMode) {
      setSelectedIds(new Set());
      setSelectAllMode(false);
    } else {
      if (dataMode === 'paginated') {
        setSelectAllMode(true);
        setSelectedIds(new Set());
      } else {
        const allResultIds = results.map((r) => r.id!);
        setSelectedIds(new Set(allResultIds));
      }
    }
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelectAllMenuItems = () => {
    if (dataMode === 'paginated') {
      setSelectAllMode(true);
      setSelectedIds(new Set());
    } else {
      const allFilteredIds = results.map((r) => r.id!);
      setSelectedIds(new Set(allFilteredIds));
      setSelectAllMode(false);
    }
    handleMenuClose();
  };

  const handleSelectPageMenuItems = () => {
    setSelectAllMode(false);
    const visibleIds = currentVisibleRows.map((r) => r.id!);
    const newSelectedIds = new Set(selectedIds);
    visibleIds.forEach((id) => newSelectedIds.add(id));
    setSelectedIds(newSelectedIds);
    handleMenuClose();
  };

  const handleDeselectAll = () => {
    setSelectedIds(new Set());
    setSelectAllMode(false);
    handleMenuClose();
  };

  const numSelected = selectedIds.size;

  return {
    selectedIds,
    selectAllMode,
    anchorEl,
    numSelected,
    handleSelectRow,
    handleSelectAllClick,
    handleMenuClick,
    handleMenuClose,
    handleSelectAllMenuItems,
    handleSelectPageMenuItems,
    handleDeselectAll,
  };
}
